import type { IAnswer } from '../../ApprovalForms/types';
import type { IApplicantQuestion } from '../../Components/Utilities/QuestionFieldGenerator';

export const getAnswerValue = (
  question: IApplicantQuestion,
  questionIndex: number,
  formResponse: IAnswer[]
): string | Record<string, string | boolean> | IAnswer['answer'] => {
  switch (question.type) {
    case 'RadioButtonField':
    case 'SelectField': {
      const choiceIds = formResponse[questionIndex]?.field_choice_ids ?? [];
      return choiceIds.length > 0 ? choiceIds[0].toString() : '';
    }
    case 'RankField':
      return formResponse[questionIndex].field_choice_ids
        ? formResponse[questionIndex].field_choice_ids.reduce(
            (acc, curr, i) => ({ ...acc, [curr]: (i + 1).toString() }),
            {}
          )
        : {};
    case 'CheckBoxField':
      return formResponse[questionIndex].field_choices.reduce<Record<number, boolean>>(
        (acc, curr) => {
          acc[curr.id] = formResponse[questionIndex].field_choice_ids.includes(curr.id);
          return acc;
        },
        {}
      );
    default:
      return formResponse[questionIndex]?.answer;
  }
};
